<template lang="pug">
  .export-record
    el-table.table(:data="exportList" style="width: 99.9%"
      :header-cell-style="{'font-size': '12px', background: '#f2f2f2', color: '#333'}")
    
      el-table-column(label="文件名称" align="center")
        template(slot-scope="scope")
          el-button(type="text" @click="download(scope.row)" v-if="scope.row.fileName") {{scope.row.fileName}}
      el-table-column(label="导入时间" align="center" prop="gmtCreated" :formatter="$tableFormat")
      el-table-column(label="操作人" align="center" prop="userName")
      el-table-column(label="上传状态" align="center")
        template(slot-scope="scope")
          span(v-if="scope.row.status === 0") 初始化
          span(v-if="scope.row.status === 1") 校验中
          span(v-if="scope.row.status === 2") 解析中
          span(v-if="scope.row.status === 3") 解析完成，处理结果文件失败
          span(v-if="scope.row.status === 4") 失败
          span(v-if="scope.row.status === 5") 成功
          span(v-if="scope.row.status === 6") 删除
      el-table-column(label="备注" align="center" prop="remark")
      el-table-column(label="上传商品结果" align="center")
        template(slot-scope="scope")
          .result 成功：{{scope.row.successNum}}
          .result 失败：
            span(type="text" v-if="!scope.row.resultFileUrl") {{scope.row.failedNum}}
            el-button(type="text" @click="download(scope.row, 'fail')" v-if="scope.row.resultFileUrl") {{scope.row.failedNum}} 下载文件

    el-pagination.pagination(background :page-size="pageSize" v-if="listCount > 0"
      :current-page="pageNo" layout="total, prev, pager, next, jumper" prev-text="上一页"
      :total="listCount" @current-change="getExportList" next-text="下一页")
</template>

<script>
import { FILE_ACCESS_PRIVATE } from '@/common/constants/'
import { getWebToken } from '@/common/utils/common'

export default {
  name: 'exportRecord',
  data() {
    return {
      exportList: [],
      pageNo: 1,
      pageSize: 20,
      listCount: 0
    }
  },
  mounted() {
    this.getExportList()
  },
  activated() {
    this.getExportList()
  },
  methods: {
    /** 获取商品列表 */
    async getExportList(page) {
      this.pageNo = page || 1
      try {
        const result = await this.$post('items.queryExcelSkuFileVOPage', {
          excelSkuVOPageQuery: {
            pageNo: this.pageNo,
            pageSize: this.pageSize
          }
        })
        if (result.success) {
          this.exportList = result.data[0].list
          this.listCount = result.data[0].recordCount
        }
      } catch (err) {
        console.log(err)
      }
    },
    download(row, type) {
      let fileUrl = type === 'fail' ? row.resultFileUrl : row.fileUrl
      try {
        let downloadElement = document.createElement('a')
        downloadElement.href = `${FILE_ACCESS_PRIVATE}${fileUrl}&_tk=${getWebToken()}`
        downloadElement.download = row.resultFileName
        document.body.appendChild(downloadElement)
        downloadElement.click()
        window.URL.revokeObjectURL(`${FILE_ACCESS_PRIVATE}${fileUrl}&_tk=${getWebToken()}`)
        document.body.removeChild(downloadElement)
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.operate-btn
  margin 0
  padding 0
  font-size 14px
</style>
